// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1JSUy","tab":"Tabs_tab__1Oi0-","tabActive":"Tabs_tabActive__X2icS"};